// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.public-intake-page {
  max-width: 840px;
  margin: 0 auto;
  padding: 40px 20px 80px;
}

.public-intake-page .pi-header {
  text-align: center;
  margin-bottom: 32px;
}

.public-intake-page .pi-header h1 {
  font-size: 2rem;
  margin-bottom: 8px;
  color: #0f172a;
}

.public-intake-page .pi-header p {
  color: #475569;
  font-size: 1rem;
}

.pi-card {
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 70px -22px rgba(15, 23, 42, 0.25);
  padding: 28px 32px;
  margin-top: 12px;
}

.pi-card h2 {
  margin: 0 0 12px;
  color: #111827;
}

.pi-subtitle {
  margin: 0 0 20px;
  color: #475569;
}

.pi-options {
  display: grid;
  gap: 16px;
}

.pi-option {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 18px 20px;
  border-radius: 12px;
  text-align: left;
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    border-color 0.15s ease;
  cursor: pointer;
}

.pi-option:hover {
  transform: translateY(-1px);
  border-color: #2563eb;
  box-shadow: 0 12px 34px -22px rgba(37, 99, 235, 0.7);
}

.pi-option.selected {
  border-color: #2563eb;
  background: rgba(37, 99, 235, 0.08);
}

.pi-option-title {
  font-weight: 600;
  color: #111827;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.pi-option-description {
  margin-top: 6px;
  color: #475569;
}

.pi-option-title-icon {
  font-size: 18px;
  color: #2563eb;
}

/* Layout for option with decorative icon */
.pi-option-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.pi-option-text {
  flex: 1 1;
}

.pi-option-icon-container {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pi-option-decorative-icon {
  font-size: 56px;
  color: #cbd5e1;
  opacity: 0.5;
  transition: all 0.3s ease;
}

.pi-option:hover .pi-option-decorative-icon {
  color: #3b82f6;
  opacity: 0.9;
  transform: scale(1.1) rotate(5deg);
}

.pi-option.selected .pi-option-decorative-icon {
  color: #2563eb;
  opacity: 1;
  transform: scale(1.05);
}

.pi-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 40px 0;
}

.pi-spinner {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 3px solid #cbd5f5;
  border-top-color: #2563eb;
  animation: pi-spin 1s linear infinite;
}

@keyframes pi-spin {
  to {
    transform: rotate(360deg);
  }
}

.pi-error {
  text-align: center;
  background: #fee2e2;
  color: #b91c1c;
  border-radius: 12px;
  padding: 24px;
}

.pi-summary {
  background: #f8fafc;
  border-radius: 12px;
  padding: 16px 20px;
  margin: 18px 0 22px;
  color: #0f172a;
}

.pi-template-description {
  margin-top: 10px;
  color: #475569;
}

.pi-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.pi-primary,
.pi-secondary,
.pi-back {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 20px;
  border-radius: 10px;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
}

.pi-primary {
  background: #2563eb;
  color: #ffffff;
  border: none;
}

.pi-secondary {
  background: rgba(37, 99, 235, 0.08);
  color: #2563eb;
  border: 1px solid rgba(37, 99, 235, 0.24);
}

.pi-back {
  background: transparent;
  border: none;
  color: #2563eb;
  padding-left: 0;
  margin-bottom: 16px;
}

@media (max-width: 640px) {
  .public-intake-page {
    padding: 32px 16px 60px;
  }

  .pi-card {
    padding: 22px 18px;
  }

  .pi-header h1 {
    font-size: 1.8rem;
  }

  .pi-options {
    gap: 12px;
  }

  .pi-actions {
    flex-direction: column;
    align-items: stretch;
  }

  .pi-option-decorative-icon {
    font-size: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/PublicIntakePage.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oDAAoD;EACpD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB;2BACyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,oDAAoD;AACtD;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".public-intake-page {\n  max-width: 840px;\n  margin: 0 auto;\n  padding: 40px 20px 80px;\n}\n\n.public-intake-page .pi-header {\n  text-align: center;\n  margin-bottom: 32px;\n}\n\n.public-intake-page .pi-header h1 {\n  font-size: 2rem;\n  margin-bottom: 8px;\n  color: #0f172a;\n}\n\n.public-intake-page .pi-header p {\n  color: #475569;\n  font-size: 1rem;\n}\n\n.pi-card {\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 20px 70px -22px rgba(15, 23, 42, 0.25);\n  padding: 28px 32px;\n  margin-top: 12px;\n}\n\n.pi-card h2 {\n  margin: 0 0 12px;\n  color: #111827;\n}\n\n.pi-subtitle {\n  margin: 0 0 20px;\n  color: #475569;\n}\n\n.pi-options {\n  display: grid;\n  gap: 16px;\n}\n\n.pi-option {\n  border: 1px solid #e2e8f0;\n  background: #ffffff;\n  padding: 18px 20px;\n  border-radius: 12px;\n  text-align: left;\n  transition: transform 0.15s ease, box-shadow 0.15s ease,\n    border-color 0.15s ease;\n  cursor: pointer;\n}\n\n.pi-option:hover {\n  transform: translateY(-1px);\n  border-color: #2563eb;\n  box-shadow: 0 12px 34px -22px rgba(37, 99, 235, 0.7);\n}\n\n.pi-option.selected {\n  border-color: #2563eb;\n  background: rgba(37, 99, 235, 0.08);\n}\n\n.pi-option-title {\n  font-weight: 600;\n  color: #111827;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pi-option-description {\n  margin-top: 6px;\n  color: #475569;\n}\n\n.pi-option-title-icon {\n  font-size: 18px;\n  color: #2563eb;\n}\n\n/* Layout for option with decorative icon */\n.pi-option-content {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.pi-option-text {\n  flex: 1;\n}\n\n.pi-option-icon-container {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pi-option-decorative-icon {\n  font-size: 56px;\n  color: #cbd5e1;\n  opacity: 0.5;\n  transition: all 0.3s ease;\n}\n\n.pi-option:hover .pi-option-decorative-icon {\n  color: #3b82f6;\n  opacity: 0.9;\n  transform: scale(1.1) rotate(5deg);\n}\n\n.pi-option.selected .pi-option-decorative-icon {\n  color: #2563eb;\n  opacity: 1;\n  transform: scale(1.05);\n}\n\n.pi-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 40px 0;\n}\n\n.pi-spinner {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 3px solid #cbd5f5;\n  border-top-color: #2563eb;\n  animation: pi-spin 1s linear infinite;\n}\n\n@keyframes pi-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.pi-error {\n  text-align: center;\n  background: #fee2e2;\n  color: #b91c1c;\n  border-radius: 12px;\n  padding: 24px;\n}\n\n.pi-summary {\n  background: #f8fafc;\n  border-radius: 12px;\n  padding: 16px 20px;\n  margin: 18px 0 22px;\n  color: #0f172a;\n}\n\n.pi-template-description {\n  margin-top: 10px;\n  color: #475569;\n}\n\n.pi-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.pi-primary,\n.pi-secondary,\n.pi-back {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 20px;\n  border-radius: 10px;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.pi-primary {\n  background: #2563eb;\n  color: #ffffff;\n  border: none;\n}\n\n.pi-secondary {\n  background: rgba(37, 99, 235, 0.08);\n  color: #2563eb;\n  border: 1px solid rgba(37, 99, 235, 0.24);\n}\n\n.pi-back {\n  background: transparent;\n  border: none;\n  color: #2563eb;\n  padding-left: 0;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 640px) {\n  .public-intake-page {\n    padding: 32px 16px 60px;\n  }\n\n  .pi-card {\n    padding: 22px 18px;\n  }\n\n  .pi-header h1 {\n    font-size: 1.8rem;\n  }\n\n  .pi-options {\n    gap: 12px;\n  }\n\n  .pi-actions {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pi-option-decorative-icon {\n    font-size: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
